export default "__VITE_ASSET__2471d064__"